module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Cap-1-c689853885e6db4393b39c3ec71d96480a9635e0e53c5da4160ed2484e0c17f1.svg";